export default __webpack_public_path__ + "fonts/vue_logo_active.3c521ecb447cf9ea5dbae9dd81d051f0.png";